export default __webpack_public_path__ + "static/media/background.36f0900a.jpg";